import { Button, Link, Progress } from '@heroui/react'
import { useMemo } from 'react'

export function HistoricalProgress({ hideInfo }: { hideInfo?: boolean }) {
  const value = 24501
  const goal = 29400
  const percent = (value / goal) * 100
  const contributors = 46

  const usd = useMemo(
    () =>
      new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      }),
    [],
  )

  const valueLabel = useMemo(() => {
    return [
      `So far ${contributors} households have contributed`,
      `${usd.format(value)} of ${usd.format(goal)} (${percent.toFixed(1)}%)`,
      `for our Historical Status application`,
    ].join(' ')
  }, [])

  return (
    <>
      <div className="w-full flex flex-col gap-2">
        <Progress
          formatOptions={{ style: 'currency', currency: 'USD' }}
          value={value}
          valueLabel={valueLabel}
          minValue={0}
          maxValue={goal}
          size="lg"
          showValueLabel
        />
        <div className='flex justify-end items-baseline gap-2'>
          {!hideInfo && (
            <Button as={Link} variant='flat' color='primary' href='/projects/historical-status'>Learn about Historical Status…</Button>
          )}
          <Button as={Link} color='primary' className='font-semibold text-default-50' href='https://app.autobooks.co/pay/windsor-park-community' target='_blank'>Click Here to Donate!</Button>
        </div>
      </div>
    </>
  )
}
